import script from "./head.vue?vue&type=script&setup=true&lang=js"
export * from "./head.vue?vue&type=script&setup=true&lang=js"

import "./head.vue?vue&type=style&index=0&id=275eb338&lang=scss&scoped=true"

import exportComponent from "/Users/anxin/Documents/Vue/河南Vue网站/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275eb338"]])

export default __exports__